module.exports = __webpack_public_path__ + "static/logo-170ec73ff87e726875b357c53d3cfa36.png";